import type { Maybe } from 'types/Utilities';

/**
 * @param args - one or more args to be used in the route (e.g., WordPress blog ID)
 * @returns Object with URLs to the AMUI routes for the given site
 */
export function routes(...args: Array<Maybe<string | number>>) {
  return {
    /** `/account/create` */
    createAccount: '/account/create',
    /** `/home` */
    home: '/home',
    /** `/account/billing` */
    billingHome: '/account/billing',
    /** `/account/call-tracking` */
    callTracking: '/account/call-tracking',
    /** `/account/call-tracking/details/call/:id` */
    callTrackingCallDetails: `/account/call-tracking/details/call/${args[0]}`,
    /** `/account/call-tracking/details/text/:id` */
    callTrackingTextDetails: `/account/call-tracking/details/text/${args[0]}`,
    /** `/account/call-tracking/numbers` */
    callTrackingNumbers: '/account/call-tracking/numbers',
    /** `/account/call-tracking/numbers/edit/:id` */
    callTrackingNumbersEdit: `/account/call-tracking/numbers/edit/${args[0]}`,
    /** `/account/call-tracking/new` */
    callTrackingNew: '/account/call-tracking/new',
    /** `/account/call-tracking/new/:id/campaign-linking` */
    callTrackingNewCampaignLinking: `/account/call-tracking/new/${args[0]}/campaign-linking`,
    /** `/account/call-tracking/new/:id/number-routing` */
    callTrackingNewNumberRouting: `/account/call-tracking/new/${args[0]}/number-routing`,
    /** `/account/call-tracking/new/:id/complete` */
    callTrackingNewComplete: `/account/call-tracking/new/${args[0]}/complete`,
    /** `/create-account` */
    createAccount2025: '/onboarding/create-account',
    /** `/keyword-explorer` */
    keywordExplorer: '/keyword-explorer',
    /** `/onboarding` */
    onboarding: '/onboarding',
    /** `/account/team-members` */
    teamMembers: '/account/team-members',
    /** `/account/team-members/accept` */
    teamMembersAccept: '/account/team-members/accept',
    /** `/account/team-members/invite` */
    teamMembersInvite: '/account/team-members/invite',
    /** `/account/team-members/edit/:team-member-id` */
    teamMembersEdit: `/account/team-members/edit/${args[0]}`,
    /** `/super/bundles` */
    bundlesList: '/super/bundles',
    /** `/super/bundles/create` */
    bundlesCreate: '/super/bundles/create',
    /** `/super/features` */
    featuresList: '/super/features',
    /** `/super/features/create` */
    featuresCreate: '/super/features/create',
    /** `/super/features/edit/:feature-id` */
    featuresEdit: `/super/features/edit/${args[0]}`,
    /** `/super/products` */
    productsList: '/super/products',
    /** `/super/products/:stripeId` */
    productsEdit: `/super/products/${args[0]}`,
    /** `/super/action-item-templates` */
    actionItemTemplatesList: '/super/action-item-templates',
    /**
     * Without ID: `/super/action-item-templates/upsert`
     * With ID: `/super/action-item-templates/upsert/:id`
     */
    actionItemTemplatesUpsert: args[0]
      ? `/super/action-item-templates/upsert/${args[0]}`
      : '/super/action-item-templates/upsert',
    /** `/account/site/:siteId/analytics` */
    analytics: `/account/site/${args[0]}/analytics`,
    /** `/account/site/:siteId/content-overview` */
    contentOverview: `/account/site/${args[0]}/content-overview`,
    /** `/account/site/:siteId/seo` */
    seo: `/account/site/${args[0]}/seo`,
    /** `/account/site/:siteId/seo/backlink-analysis` */
    backlinkAnalysis: `/account/site/${args[0]}/seo/backlink-analysis`,
    /** `/account/site/:siteId/seo/domain-overview` */
    domainOverview: `/account/site/${args[0]}/seo/domain-overview`,
    /** `/account/site/:siteId/seo/search-performance */
    searchPerformance: `/account/site/${args[0]}/seo/search-performance`,
    /** `/account/site/:siteId/seo/site-audit` */
    siteAudit: args?.[1]
      ? `/account/site/${args[0]}/seo/site-audit/${args[1]}`
      : `/account/site/${args[0]}/seo/site-audit`,
    /** `/account/site/:siteId/settings/google-search-console` */
    siteSettingsGsc: `/account/site/${args[0]}/settings/google-search-console`,
    /** `/account/site/:siteId/settings/delete` */
    siteSettingsDelete: `/account/site/${args[0]}/settings/delete`,
    /** `/account/switch/:accountId */
    switchAccount: `/account/switch/${args[0]}`,
  };
}
